export enum VariationStatus {
    Draft = 'Draft',
    PendingForApproval = 'Pending For Approval',
    Approved = 'Approved',
    Rejected = 'Rejected'
}

export const VariationStatusMap: { [key: string]: any } = {
    'draft': VariationStatus.Draft,
    'pending': VariationStatus.PendingForApproval,
    'approved': VariationStatus.Approved,
    'rejected': VariationStatus.Rejected,

    [VariationStatus.Draft]: 'draft',
    [VariationStatus.PendingForApproval]: 'pending',
    [VariationStatus.Approved]: 'approved',
    [VariationStatus.Rejected]: 'rejected',

}

export const VariationStatusColorMap: { [key: string]: string } = {
    [VariationStatus.Draft]: '#AAAAAA',
    [VariationStatus.PendingForApproval]: '#F39226',
    [VariationStatus.Approved]: '#5EC641',
    [VariationStatus.Rejected]: '#EC3324',
}
